import type { AppsAndroidDownloadsAndEngagementDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsDownloadsAndEngagementFilter } from "app/pages/sales-intelligence/store/find-apps/types";

import { BaseDownloadsAndEngagementFilter } from "../DownloadEngagementFilter/BaseDownloadEngagementFilter";

export default class FindAndroidDownloadAndEngagementFilter extends BaseDownloadsAndEngagementFilter<
    IAppsDownloadsAndEngagementFilter,
    AppsAndroidDownloadsAndEngagementDescriptionDto
> {}
